module.exports = __webpack_public_path__ + "static/media/star-icon.3a4a0105.svg";